import { isSvgFile } from './svgDetect';
import { requestSvgConversion, type SvgConvertTarget } from './svgConvertStore';

/**
 * 圖片上傳前的共用關卡(R415):SVG → 跳轉檔確認視窗,其他檔案原樣放行。
 * -----------------------------------------------------------------------------
 * **每一個圖片上傳入口**都在「驗證 / 上傳之前」呼叫這裡(`svgUploadGate.test` 機械鎖:
 * 檔案選擇器 accept 收 SVG 的檔案,一定要呼叫這支)。順序固定:
 *
 *   選檔 / 拖放 → prepareImageUpload(s) → validateImageFile → upload
 *
 * `validateImageFile` 拒收 SVG 那道**照留**:它是轉檔漏接時的最後防線,不是這裡的替代品。
 *
 * 目的地決定透明背景的去留(owner 2026-10-13「前端補白底」):
 *   - Logo(品牌規範 Logo、畫布 Logo 格)→ `allowTransparent: true`,PNG 可以保留透明;
 *   - 其他一律白底 —— 透明 PNG 進到非 Logo 的格子,後端拼格網時會丟掉 alpha,AI 看到黑底。
 */

export type PrepareImageTarget = SvgConvertTarget;

/** 單檔:SVG → 使用者確認後的 PNG / JPG(取消 = null);其他檔案原樣回傳(同一個參考)。 */
export async function prepareImageUpload(file: File, target: PrepareImageTarget): Promise<File | null> {
  if (!(await isSvgFile(file))) return file;
  return requestSvgConversion(file, target);
}

/**
 * 一批檔案:先認出哪些是 SVG,再依序一張一張問(視窗顯示「第 i / n 張」);
 * 取消的那幾張從結果拿掉,其餘保持原本的順序。
 */
export async function prepareImageUploads(files: readonly File[], target: PrepareImageTarget): Promise<File[]> {
  const flags = await Promise.all(files.map((f) => isSvgFile(f)));
  const total = flags.filter(Boolean).length;
  if (total === 0) return [...files];
  const out: File[] = [];
  let index = 0;
  for (const [i, file] of files.entries()) {
    if (!flags[i]) {
      out.push(file);
      continue;
    }
    index += 1;
    const converted = await requestSvgConversion(file, target, { index, total });
    if (converted) out.push(converted);
  }
  return out;
}
